import PageLayout from "../../layouts/PageLayout"
import HeroHeader from "../../components/HeroHeader"
import Background from "../../assets/ContactHeader.jpg"
import ContactSection from "../../components/ContactSection"
import LocationMap from "../../components/LocationMap"
import { MAPS_SEARCH_URL } from "../../constants/address"
import { PHONE_DISPLAY, PHONE_HREF } from "../../constants/contactInfo"
import { overlineSx, pillButtonSx } from "../../styles/sectionStyles"
import { Box, Button, Container, Grid, Stack, Typography } from "@mui/material"
import { Link } from "react-router-dom"

const Contact = () => (
    <PageLayout
        hero={
            <HeroHeader
                background={Background}
                backgroundPosition="center right"
                overline="Stargate Rentals"
                title="Contact"
                subtitle="Enquire about Private Hire vehicle hire, ask what's included, or arrange a collection from our Blaydon office."
                cta={{ label: `Call ${PHONE_DISPLAY}`, href: PHONE_HREF }}
            />
        }
    >
        <ContactSection variant="light" />

        <Box
            component="section"
            sx={{
                py: { xs: 6, md: 8 },
                background: "#000435",
                color: "#fff",
                position: "relative",
                overflow: "hidden",
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    background:
                        "radial-gradient(ellipse 60% 80% at 20% 50%, rgba(0, 163, 255, 0.12), transparent 55%)",
                    pointerEvents: "none",
                }}
            />

            <Container maxWidth="lg" sx={{ position: "relative" }}>
                <Grid container spacing={{ xs: 3, md: 5 }} alignItems="center">
                    <Grid item xs={12} md={4}>
                        <Stack spacing={2} data-aos="fade-right" data-aos-duration="800">
                            <Typography variant="overline" sx={overlineSx}>
                                Office
                            </Typography>
                            <Typography variant="h4" fontWeight={800} lineHeight={1.15}>
                                Find us in Blaydon
                            </Typography>
                            <Typography variant="body1" sx={{ opacity: 0.78, lineHeight: 1.7 }}>
                                Collect your vehicle from Unit 9B, Galaxy Business Park — convenient
                                for drivers across Newcastle and the North East.
                            </Typography>
                            <Box>
                                <Button
                                    component={Link}
                                    to={MAPS_SEARCH_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    variant="outlined"
                                    size="large"
                                    sx={{
                                        ...pillButtonSx,
                                        px: 3,
                                        borderColor: "rgba(0, 163, 255, 0.55)",
                                        color: "#fff",
                                        "&:hover": {
                                            borderColor: "#00A3FF",
                                            background: "rgba(0, 163, 255, 0.1)",
                                        },
                                    }}
                                >
                                    Open in Google Maps
                                </Button>
                            </Box>
                        </Stack>
                    </Grid>

                    <Grid item xs={12} md={8}>
                        <Box
                            data-aos="fade-left"
                            data-aos-duration="800"
                            sx={{
                                borderRadius: 3,
                                overflow: "hidden",
                                border: "1px solid rgba(255,255,255,0.12)",
                                boxShadow: "0 28px 60px rgba(0, 0, 0, 0.35)",
                                "& iframe, & > div": {
                                    height: { xs: 280, md: 380 },
                                },
                            }}
                        >
                            <LocationMap />
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    </PageLayout>
)

export default Contact
